<lo-dialog heading="Auto top-up" data-testid="auto-top-up-dialog">
	<div class="content">
		<p class="lo-type-text-md subtitle">
			Automatically buy more credits when your balance runs low.
		</p>

		<div class="toggle-row">
			<lo-toggle
				label="Enable auto top-up"
				[value]="enabled"
				[disabled]="saving || (!hasSavedCard && !enabled)"
				(valueChange)="onToggle($event)"
			></lo-toggle>
			<p class="lo-type-text-xs hint" data-testid="auto-top-up-cap">
				{{ capNote }}
			</p>
		</div>

		@if (!hasSavedCard) {
		<lo-notice
			compact
			tone="warning"
			heading="A payment method is required"
			body="Auto top-up charges a saved card, so add one first. We'll open Stripe's secure billing portal — add your card there and you'll come straight back to this page."
		>
			<button
				lo-button
				size="sm"
				type="button"
				data-testid="add-payment-method"
				[loading]="portalOpening"
				(click)="addPaymentMethod()"
			>
				Add payment method
			</button>
		</lo-notice>
		} @if (data.settings.disabled_reason) {
		<lo-notice
			compact
			tone="warning"
			data-testid="auto-recharge-paused"
			[heading]="
				'Auto top-up was paused because ' +
				pausedReason(data.settings.disabled_reason) +
				'.'
			"
		></lo-notice>
		} @if (enabled) {
		<div class="fields">
			<lo-number-field
				label="When my balance falls below"
				placeholder="1000"
				suffix="credits"
				[formControl]="thresholdControl"
				[min]="0"
			></lo-number-field>

			<lo-number-field
				label="Top up with"
				placeholder="100"
				prefix="$"
				[formControl]="amountControl"
				[min]="minAmountUsd"
				[max]="maxAmountUsd"
				[hint]="amountHint"
				[error]="amountError"
			></lo-number-field>
		</div>
		}
	</div>

	<div loDialogActions>
		<button
			lo-button
			variant="secondary"
			type="button"
			[disabled]="saving"
			(click)="dismiss()"
		>
			Cancel
		</button>
		<button
			lo-button
			type="button"
			[loading]="saving"
			[disabled]="!canSave && !saving"
			(click)="save()"
		>
			Save
		</button>
	</div>
</lo-dialog>
